import React from 'react'

import RaisedButton from 'material-ui/RaisedButton'
import PhotoLibraryIcon from 'material-ui/svg-icons/image/collections'
import Analytics from 'infra/analytics/Analytics'

export default class ChatTextInput extends React.Component {

  componentWillReceiveProps(nextProps) {
    if(this.props.roomId !== nextProps.roomId) {
      this.resetInputArea()
    }
  }

  componentDidMount() {
    //autosize(this.inputArea);
  }

  resetInputArea = () => {
    if (this.inputArea) {
      this.inputArea.value = ''
      this.inputArea.rows = 1
    }
  }

  sendTextMessage = () => {
    // Send message only if there is a message
    if (this.inputArea.value.match(/\S/g)){
      this.props.sendTextMessage(this.inputArea.value)
      this.resetInputArea()
      Analytics.track(Analytics.MESSAGE_SENT)
    }
  }

  sendImage = (file) => {
    this.props.onFileInputChange(file)
    Analytics.track(Analytics.IMAGE_UPLOADED)
  }

  onKeyDown = (event) => {
    if (event.nativeEvent.keyCode === 13 && event.nativeEvent.shiftKey) {
      this.inputArea.rows++
      return true
    }
    if (event.nativeEvent.keyCode === 13 && !event.nativeEvent.shiftKey) {
      event.preventDefault()
      this.sendTextMessage()
      return false
    }
    return true
  }

  render() {
    if (this.props.isLoading) {
      return null
    }
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          paddingLeft: 11,
          paddingRight: 11,
          flexShrink: 0,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f7f7f7',
          borderTopStyle: 'solid',
          borderTopWidth: 1,
          borderTopColor: '#D3D3D3'
        }}>

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexGrow: 1,
            marginTop: 14,
            marginBottom: 14,
            marginRight: 11,
            alignItems: 'center',
            borderRadius: 3,
            backgroundColor: 'white',
            border: 'solid 1px rgba(0, 0, 0, 0.12)'
          }}>

          <textarea
            ref={textarea => this.inputArea = textarea}
            style={{
              display: 'flex',
              flexGrow: 1,
              fontSize: 14,
              paddingLeft: 11,
              paddingTop: 8,
              margin: 0,
              alignSelf: 'stretch',
              resize: 'none',
              border: 'none',
              maxHeight: 72
            }}
            rows={1}
            placeholder={'Type message, shift + enter for new line'}
            onKeyDown={this.onKeyDown} />

          <div
            style={{ position: 'relative', width: 36, height: 36 }}>

            <input
              style={{
                opacity: 0,
                cursor: 'pointer',
                position: 'absolute',
                top: 0,
                left: 0,
                width: 36,
                height: 36
              }}
              type="file"
              accept=".jpg, .jpeg, .png, .gif"
              onChange={this.sendImage}
              multiple
            />
            <PhotoLibraryIcon
              style={{ padding: 4 }}
              color='#527da3'/>
          </div>
        </div>

        <RaisedButton
          label="Send"
          primary={true}
          onTouchTap={this.sendTextMessage}
          style={{ height: 36, width: 118 }}
          labelStyle={{ textTransform: 'none', fontWeight: 'normal' }} />

      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/chat/ChatTextInput.js